module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSI5IiB2aWV3Qm94PSIwIDAgMTYgOSI+CiAgICA8cGF0aCBmaWxsPSIjRkY0MDUyIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik05IDYuNGgzLjZMOSAyLjhsLTQgNEwuMyAyLjEgMS43LjcgNSA0bDQtNCA1IDVWMS40aDJ2N0g5eiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/down-icon.svg
// module id = GIed
// module chunks = 1